import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '新金瓶梅',
    url: 'https://xinjinpingmei.com',
    description: '经典名著全新解读与深度赏析，汇聚学术赏析、文化背景、人物解析与版本考证',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://xinjinpingmei.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '新金瓶梅',
    url: 'https://xinjinpingmei.com',
    description: '专注于《金瓶梅》研究、解读与传播的学术文化平台',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '海淀区',
      streetAddress: '中关村南大街5号',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@xinjinpingmei.com',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategorySection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}